import script from "./goods-spec-select-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./goods-spec-select-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./goods-spec-select-dialog.vue?vue&type=style&index=0&id=c1375bbc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1375bbc"]])

export default __exports__